import { AbstractControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  @Input() directory: string;

/* --------------------------------- Fields --------------------------------- */
  mediaList: File[] = [];
  @Input()
  type: string; // IMAGE, VIDEO, FILE
  @Input() fileInput: any;
  /* ------------------------------- constructor ------------------------------ */

  constructor() { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }


  setFiles(fileList: FileList){
    for(let i=0; i < fileList.length; i++) {
      this.mediaList.push(fileList.item(i));
    }
  }

  addFile(ev: any){
    if(this.fileInput?.value){
      this.fileInput?.value.push(ev);
    } else {
      this.fileInput?.setValue([ev]);
    }
  }

  removeUrl(i: number){
    this.fileInput.setValue(this.fileInput.value.filter((single:any, index: number)=> index !==i));
  }

}
